import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useCheckPaymentsPossibility = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const fetchData = async () => {
    const response = await Promise.all([
      dispatch.application.getSystemPropertyValue('FORCE_DISABLE_PAYMENTS'),
      dispatch.application.getEodStatus()
    ]);
    const [
      {
        data: { value: disablePaymentsBySystemProperty }
      },
      { eodProcessing }
    ] = response;
    const shouldDisablePayments =
      eodProcessing || disablePaymentsBySystemProperty;
    dispatch.application[
      shouldDisablePayments ? 'disablePayments' : 'enablePayments'
    ]();
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);
  return { loading };
};

export default useCheckPaymentsPossibility;
